<template>
  <div class="bodyDetail">
    <el-dialog
      title="批量导入试题"
      :visible.sync="dialogVisible"
      width="60%"
    >

      <el-form
        ref="form"
        label-width="80px">

        <el-form-item label="模板下载">
          <el-link :href="config.files.template.questionBatchImport" type="primary" :underline="false">批量导入试题模版</el-link>
        </el-form-item>

        <el-input
          :disabled="true"
          type="textarea"
          :rows="6"
          placeholder="请输入内容"
          v-model="importMsg">
        </el-input>

        <el-alert
          style="margin-top: 15px"
          title="说明"
          type="info"
          close-text="知道了"
          show-icon>
          <p>1、请通过平台提供的《批量导入试题模版》填写相应的试题数据，然后点击导入按钮将试题信息导入到题库当中</p>
          <p>2、试题编号在同一题库当中不能重复</p>
        </el-alert>

        <div style="margin-top: 30px">
          <oss-upload
            :is-slot="true"
            :limit="undefined"
            :limitSize="undefined"
            :type="'temp'"
            showFileLis="false"
            :accept="'.xlsx'"
            :drag="false"
            :showFileList="false"
            :isSlot="true"
            :onElSuccess="onOssSuccess"
            @onBefore="onOssBefore"
          >
            <el-button :loading="loading" size="small" type="primary">点击上传</el-button>
          </oss-upload>
        </div>


      </el-form>
    </el-dialog>
  </div>
</template>


<script>

import config from '@/config/config.js'
import ossUpload from "@/components/common/oss/ossUpload";
import $ossConstant from "@/components/common/oss/ossConstant";

import questionBankApi from '@/api/api_question_bank.js'
import weClient from "@/common/we/weClient.js";

export default {
  components: {ossUpload},
  data() {
    return {
      ossConstant: $ossConstant,
      config: config,
      dialogTitle: undefined,
      questionBankId: undefined,
      dialogVisible: false,
      importMsg: '未上传',

      vid: undefined,
      loading: false
    }
  },
  destroyed() {
    console.log('user br destroyed');
    weClient.close(this.vid);
  },
  methods: {
    show(questionBankId) {
      this.questionBankId =  questionBankId;
      this.dialogVisible = true;
      this.importMsg = '未上传';
    },
    initWe(vId){
      if (this.vid) {
        return;
      }
      this.vid = vId;
      weClient.initWe(vId, {
        onMessage: this.weOnMessage,
        onClose: this.weOnClose
      })
    },
    weOnMessage(key, data){
      console.log('we on message', data);
      if (data.stage == 1) {
        this.importMsg = "表格内容检测中...";
      } else if (data.stage == 2) {
          this.importMsg = this.convertErrorMsg(data.data);
          this.closeImport();
      } else if (data.stage == 3) {
        this.importMsg = '导入中...';
      } else if (data.stage == 4) {
        this.importMsg = '导入失败';
        this.closeImport();
      } else {
        this.importMsg = '导入成功';
        this.closeImport();
        this.$emit("onImportSuccess");
      }
    },
    closeImport(){
      this.loading = false;
      weClient.close(this.vid);
      this.vid = undefined;
    },
    convertErrorMsg(errorDataArray) {
      let str = '表格内容错误，请根据以下要求修改后再重新导入:\n';
      for (let index in errorDataArray) {
        str += errorDataArray[index] + '\n';
      }
      return str;
    },
    weOnClose(data) {
      console.log('we on close', data);
    },
    onOssBefore() {
      this.loading = true;
      this.importMsg = "正在上传文件中...";
    },
    onOssSuccess(data) {
      let params = {
        questionBankId: this.questionBankId,
        importTempFileKey: data.key
      }

      questionBankApi.batchImportQuestion(params).then(res => {
        console.log('batch import question res', res);
        this.initWe(res.data.vid);
      }).catch(error => {
        this.loading = false;
        this.$message.error({
          showClose: true,
          message: "请求出现异常",
          duration: 2000
        });
      })
    }
  }
}

</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/pages/examination/components/questionBatchImport.vue